export const backgroundColorMap = {
    "white": "has-background-white",
    "black": "has-background-black",
    "light": "has-background-light",
    "dark": "has-background-dark",
    "primary": "has-background-primary",
    "link": "has-background-link",
    "info": "has-background-info",
    "success": "has-background-success",
    "warning": "has-background-warning",
    "danger": "has-background-danger",
}


export type ColorType =
    "white"
    | "black"
    | "light"
    | "dark"
    | "primary"
    | "link"
    | "info"
    | "success"
    | "warning"
    | "danger"